import hash from "../../hash";
import { createApp } from "vue";


import { ModalHelper } from "../../B2bTools";
import html from "./groups.html";
import htmlNew from "./groups@new.html";
import { traduit } from "../composant/b2bLangue";

import Fuse from 'fuse.js'
const fuseOptions = {
    threshold: 0.0,
    keys: [
        'v'
    ]
}

const js = ({
    url: function (echangeur) {
        echangeur.addAction('groupe.list', {}, 'form', 'groupes')
    },
    onLoad: function (echangeur) {

        let THIS = this;

        // retail wholesale
        const app = createApp({

            data: () => ({
                groupes: echangeur.groupes.rows,

                fuse: null,
                searchKey: '',
                // fuse: null,
                // search: null,
                // searchKey: null
            }),
            methods: {
                groupDetail(e) {
                    hash.lance("groupDetail", { _id: e._id })
                },

                lanceRecherche(val) {
                    const index = 'v'
                    const data = this.groupes
                    if (data && val) {
                        const searchIndex = this.fuse.search(val).map(u => u.item[index]);
                        data.map(u => u.inSearch = (searchIndex.includes(u[index])))
                    }
                },

                // lanceRecherche(val) {
                //     this.search = this.fuse.search(val);
                //     let indexSearch = this.search.map(e => {
                //         return e.item._id;
                //     });
                //     let countUserAff = 0;
                //     this.groupes.map(u => {
                //         u.inSearch = (indexSearch.indexOf(u._id) > -1);
                //         if (u.show) countUserAff += 1;
                //     })
                // },
                groupNew(e) {
                    const modaleApp = createApp({
                        data: () => ({
                            saisie: {
                                v: "",
                                type: 'retail',
                            },
                            errors: {
                                v: null,
                                type: null,
                                nb: 0
                            }
                        }),
                        methods: {

                            close() {
                                ModalHelper.hide();
                            },

                            async valide() {
                                function nbe(objet) {
                                    let nb = 0;
                                    for (let key in objet) if (objet[key]) nb++;
                                    return nb;
                                }

                                this.errors.message = "";
                                this.errors.v = false;
                                this.errors.type = false;

                                if (this.saisie.v == "") { this.errors.v = true; }
                                if (this.saisie.type == "") { this.errors.type = true; }

                                this.errors.nb = nbe(this.errors);

                                if (this.errors.nb == 0) {
                                    let result = await THIS.rest("groupe.create", { _id: "_new" }, this.saisie);
                                    if (!result.ok) {
                                        this.errors.message = result.message;
                                    } else {
                                        ModalHelper.hide();
                                        hash.lance("groupDetail", { _id: result.doc._id })
                                    }
                                }
                            },
                        },
                        mounted() {
                            ModalHelper.show(function () {
                                modaleApp.unmount();
                            });
                        }
                    })
                    modaleApp.mount(ModalHelper.html(htmlNew).container);
                },

                t(value) {
                    return traduit(value, 'global');
                }

            },
            watch: {
                "searchKey"(val) {
                    this.lanceRecherche(val);
                }
            },
            mounted() {
                this.fuse = new Fuse(this.groupes, fuseOptions);
                //this.fuse = new Fuse(this.groupes, { includeScore: false, threshold: 0.2, keys: ['v'] });
            }
        });

        app.mount(THIS.c$('._vueChargement')[0]);

    },

});

export default {
    groups: { js: js, html: html }
};
